module.exports = __webpack_public_path__ + "static/media/covington-final.7b81e3c8.jpg";